import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import InboxTransitionBase from './InboxTransitionBase';
import { getFirstName } from '../../util/user';

const InboxTransitionDecline = ({ transition, user, ownRole, buttons }) => {
  const isOwnTransition = transition.by === ownRole;
  const displayName = getFirstName(get(user, 'attributes.profile.displayName', ''));

  return (
    <InboxTransitionBase
      header={
        isOwnTransition ? (
          <FormattedMessage id="BookingStatus.ownTransitionDecline" values={{ displayName }} />
        ) : (
          <FormattedMessage id="BookingStatus.transitionDecline" values={{ displayName }} />
        )
      }
      date={transition.createdAt}
      direction="left"
      buttons={buttons}
    >
      {isOwnTransition ? (
        <FormattedMessage id="BookingStatus.transitionDeclineSubtext" />
      ) : (
        <FormattedMessage id="BookingStatus.transitionDeclineSubtext" />
      )}
    </InboxTransitionBase>
  );
};

export default InboxTransitionDecline;
